import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { IEnumModel } from './../../../../../app/models/enum.model';
import Swal from 'sweetalert2';
import { BaseFormComponent } from './../../../../../app/shared/components/base-form/base-form.component';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { IModeloRelatorioModel } from './../../../../../app/models/modelo-relatorio.model';
import { AuthService } from './../../../../../app/services/auth.service';
import { IOsaExecucaoPapelTrabalho, IOsaExecucaoPapelTrabalhoArquivo } from './../../../../../app/models/osa-execucao-papel-trabalho.model';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { FileService } from './../../../../../app/services/file.service';
import { OsaExecucaoPapelTrabalhoService } from './../../../../../app/services/osa-execucao-papel-trabalho.service';
import { IBaseModel } from './../../../../../app/models/base.model';
import { OsaExecucaoAbaPapaeisModalIncluirComponent } from './osa-execucao-aba-papaeis-modal-incluir/osa-execucao-aba-papaeis-modal-incluir.component';

export type IModeloRelatoria = {
  modeloRelatorio: IModeloRelatorioModel[] | IModeloRelatorioModel | any;
  modeloRelatorioId: number | any;
  habilitarGerarRelatoria: boolean;
  status: IEnumModel;
  situacao: IEnumModel;

}
@Component({
  selector: 'app-osa-execucao-aba-papeis',
  templateUrl: './osa-execucao-aba-papeis.component.html',
  styleUrls: ['./osa-execucao-aba-papeis.component.scss']
})
export class OsaExecucaoAbaPapeisComponent extends BaseFormComponent implements OnInit {

  @Input() visualizar: boolean = false;
  @Input() submit: boolean = false;
  @Input() public impressao: boolean = false;

  model: IOsaExecucaoPapelTrabalho[] = [];
  modelRemovidos: IOsaExecucaoPapelTrabalho[] = [];

  constructor(
    route: ActivatedRoute,
    toastr: ToastrService,
    router: Router,
    localeService: BsLocaleService,
    private authService: AuthService,
    public matDialog: MatDialog,
    private fileService: FileService,
    private osaExecucaoPapelTrabalhoService: OsaExecucaoPapelTrabalhoService
  ) {
    super(route, toastr, router, localeService, matDialog);
  }

  ngOnInit(): void {

  }

  ngAfterViewInit(): void {
    
    this.carregaPapeisTrabalho();

  }

  ngOnChanges(changes: SimpleChanges): void {
    
  }

  ngDoCheck() {
    
  } 

  carregaPapeisTrabalho() {
    this.osaExecucaoPapelTrabalhoService
      .obterPorExecucao(this.id)
      .then((res) => {
        this.model = res.dados as IOsaExecucaoPapelTrabalho[];
        this.atualizaPosicoes();
      })
      .catch((err) => {
        this.exibirMensagemAlerta(err.mensagem.descricao);
      })
  }

  public async uploadArquivo(e, item: IOsaExecucaoPapelTrabalho) {

    if (item.arquivos == null || item.arquivos == undefined)
      item.arquivos = [];

    let file = (e.target as HTMLInputElement).files;

    let flatListFiles = Array.from(file);

    let qtdSelecionada = flatListFiles.length;
    let qtdJaAdd = item.arquivos.length;
    if (qtdSelecionada + qtdJaAdd > 5) {
      this.exibirMensagemAlerta("Não é permitido mais do que 5 arquivos selecionados", false, "");
      return;
    }

    for (let index = 0; index < file.length; index++) {
      let tipo = flatListFiles[index].type.toUpperCase();
      let size = Math.trunc(flatListFiles[index].size / 1024 / 1024);

      //PDF, PNG, JPG, XLSX e/ou MP4
      //EXCEL OU VND.OPENXMLFORMATS-OFFICEDOCUMENT.SPREADSHEETML.SHEET
      if (tipo.includes("PDF") == false
        && tipo.includes("PNG") == false
        && tipo.includes("JPG") == false
        && tipo.includes("JPEG") == false
        && tipo.includes("MP4") == false
        && tipo.includes("EXCEL") == false
        && tipo.includes("VND.OPENXMLFORMATS-OFFICEDOCUMENT.SPREADSHEETML.SHEET") == false) {
        this.exibirMensagemAlerta("O formato do arquivo deve ser PDF, PNG, JPG, XLSX e/ou MP4", false, "");
        return;
      }

      if (tipo.includes("MP4")) {
        if (size > 28) {
          this.exibirMensagemAlerta("Não é permitido videos com mais de 28Mb", false, "");
          return;
        }
      }
      else if (size > 28) {
        this.exibirMensagemAlerta("Não é permitido arquivos com mais de 28Mb", false, "");
        return;
      }

      let fileToArray = await this.getBase64(file[index]);
      let novoArquivo = new IOsaExecucaoPapelTrabalhoArquivo();
      novoArquivo.id = 0;
      novoArquivo.nome = flatListFiles[index].name;
      novoArquivo.arquivo = fileToArray.toString();
      novoArquivo.controle = item.arquivos.length + 1;
      novoArquivo.tipo = flatListFiles[index].type;
      item.arquivos.push(novoArquivo)
    }
  }

  public getBase64(file) {
    return new Promise((resolve, reject) => {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        resolve(reader.result)
      };
      reader.onerror = function (error) {
        Swal.fire({
          toast: true,
          position: 'top-end',
          icon: 'error',
          text: "Ocorreu um erro ao selecionar o arquivo" + error.toString(),
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
        })
      };
    })
  }

  exibeSalvar() {
    return this.model != null && this.model.length > 0;
  }

  async salvar(sair: boolean) {

    if (this.model == null || this.model.length == 0) {
      this.exibirMensagemAlerta('Não tem Papéis de Trabalho do tipo Auditoria.');
      return;
    }
    try {

      for (let i = 0; i < this.model.length; i++) {
        const element = this.model[i];
        element.osaExecucaoId = this.id;
      }

      let res: IBaseModel<void> = null;
      res = await this.osaExecucaoPapelTrabalhoService.salvar(this.model, this.modelRemovidos, this.id);

      if (res.sucesso) {
        Swal.fire({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
          icon: 'success',
          text: res.mensagem.descricao
        });

        this.exibirMensagemSucesso(res.mensagem.descricao);

        if (sair)
          this.router.navigate(['/osa-execucao']);
        else
          this.ngAfterViewInit();

      } else {
        this.exibirMensagemAlerta(res.mensagem.descricao);
      }
    }
    catch (err) {
      this.exibirMensagemErro(err.mensagem.descricao);
    }
  }

  drop(event: CdkDragDrop<IOsaExecucaoPapelTrabalho[]>) {
    moveItemInArray(this.model, event.previousIndex, event.currentIndex);
    this.atualizaPosicoes();
  }

  atualizaPosicoes() {
    for (let i = 0; i < this.model.length; i++) {
      let element = this.model[i];
      element.posicao = i + 1;
    }
  }

  removeFile(item: IOsaExecucaoPapelTrabalho, arquivo: IOsaExecucaoPapelTrabalhoArquivo) {
    if (arquivo.id == 0) {
      item.arquivos = item.arquivos.filter(f => f.controle != arquivo.controle);
    }
    else {
      //Salva os removidos para remover no banco
      if (item.removidos == null || item.removidos == undefined)
        item.removidos = [];
      item.removidos.push(item.arquivos.find(f => f.id == arquivo.id));

      item.arquivos = item.arquivos.filter(f => f.id != arquivo.id);
    }
  }

  isValidUrl(value: string): boolean {
    const pattern = /^(https?:\/\/)?([a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,}))(:\d+)?(\/[^\s]*)?$/;
    return pattern.test(value);
  }

  exibeJustificativa(item: IOsaExecucaoPapelTrabalho) {
    if (item.sigla == "PT") {
      return true;
    }
    else {
      if (item.idTipoAceitavel != 2 && (item.arquivos == null || item.arquivos.length == 0)) {
        return true;
      }
      else if (item.idTipoAceitavel == 2 && this.isValidUrl(item.link) == false) {
        return true;
      }
    }

    return false;
  }

  getSigla(item: IOsaExecucaoPapelTrabalho) {
    return item.sigla + "-" + (item.posicao).toString().padStart(2, "0");
  }

  async novoPapel() {
    const dialogRef = this.matDialog.open(OsaExecucaoAbaPapaeisModalIncluirComponent, {
      data: { listPapeis: this.model },
      width: '650px',
      hasBackdrop: true,
      disableClose: true,
      id: 'modal-papel-nao-cadastrado'
    });

    dialogRef.afterClosed().subscribe(async result => {
      if (result) {
        this.atualizaListaAdd(result);
      }
    });
  }

  atualizaListaAdd(nomePapel: string) {
    const novo: IOsaExecucaoPapelTrabalho = {
      id: 0,
      nomePapel: nomePapel,
      nomePapelManual: nomePapel,
      sigla: "PTE",
      addManual: true,
      osaExecucaoId: this.id,
      idTipoAceitavel: 1,
      arquivos: [],
      justificativa: "",
      link: "",
      posicao: this.model.length + 1,
      situacaoNome: ""
    };
    this.model.push(novo);
  }

  removePapel(item: IOsaExecucaoPapelTrabalho) {

    if (item.id > 0) {
      this.modelRemovidos.push(this.model.find(f => f.id == item.id));
    }
    else if (item.idPapel > 0) {
      this.modelRemovidos.push(this.model.find(f => f.idPapel == item.idPapel));
    }
    this.model = this.model.filter(f => f.posicao != item.posicao);
    this.atualizaPosicoes();
  }

  getSituacao(item: IOsaExecucaoPapelTrabalho) {
    return !item.situacaoNome? "" : "(" + item.situacaoNome + ")";
  }

  imprimir() {
    this.router.navigate([`osa-execucao/${this.id}/papeis-trabalho/imprimir`], {state: {id: this.id}})
  }

  exibeLink(item: IOsaExecucaoPapelTrabalho) {
    return item.idTipoAceitavel == 2;
  }

  exibeRemoverPapel(item: IOsaExecucaoPapelTrabalho) {
    return this.visualizar == false && (item.addManual || item.situacaoNome?.toUpperCase() == 'OPCIONAL');
  }

  public download(arquivo: IOsaExecucaoPapelTrabalhoArquivo) {
    this.osaExecucaoPapelTrabalhoService.downloadAnexo(arquivo.id).then((res) => {
      if (res.sucesso) {
        const link = document.createElement("a");
        link.href = res.dados.toString();0
        link.download = arquivo.nome;
        link.click();
      } else {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "warning",
          text: res.mensagem.descricao,
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
        });
      }
    })
  }
}

